import * as React from 'react';
import { ukCountry } from '../../core/constants';
import { country } from '../../config.local';
import FooterLink from './FooterLink';

const PrivacyLink = () => {
	const getUrl = () => {
		if (country === ukCountry) return 'https://vetting.com/en-gb/privacy-policy';
		return 'https://vetting.com/en-au/privacy-policy';
	};
	return <FooterLink text="Privacy" href={getUrl()} />;
};

export default PrivacyLink;
